<template>
    <MainContentTabs
        :tabs="[
            {tab : 'posiciones', nombre: 'Posiciones'},
        ]"
        initialTab="posiciones"
        title="Deportistas"
    >
        <template slot="posiciones">
            <Posiciones/>
        </template>
    </MainContentTabs>
</template>

<script>
    import MainContentTabs from '@/components/backend/components/MainContentTabs';
    import Posiciones from '@/components/backend/bases/components/Posiciones';

    export default {
        components: {
            MainContentTabs, Posiciones
        }
    }
</script>